const defaultAjaxTimeoutMilliseconds = 1000;

export async function makeJsonRequest({
  url,
  method = "POST",
  bodyData = {},
  timeout = defaultAjaxTimeoutMilliseconds,
  onSuccess = async (responseBodyData) => {},
  onError = async (statusCode, responseBodyData, errorMessage) => {
    await window.confirmationModal.tellBlocking(errorMessage);
  },
  onDone = async () => {},
  messageOnTimeout = 'Server not responding.\nInternet may be unavailable.',
  defaultErrorMessage = 'Something went wrong.\nPlease reload the page and try again.',
  statusCodesForSuccess = {
    'POST': 201,
    'default': 200,
  },
} = {}) {
  const controller = new AbortController();
  const { signal } = controller;
  const contentType = 'application/json';
  const accept = 'application/json';

  const timeoutId = setTimeout(async () => {
    controller.abort();
    await window.confirmationModal.tellBlocking(messageOnTimeout);
    clearTimeout(timeoutId);
  }, 240000);

  let response;

  try {
    const headers = {};

    if (accept) {
      headers['Accept'] = accept;
    }
    if (contentType) {
      headers['Content-Type'] = contentType;
    }

    response = await fetch(url, { method, body: JSON.stringify(bodyData), headers });
    const responseStatus = response.status;

    const statusCodeForSuccess = (statusCodesForSuccess[method] || statusCodesForSuccess['default']);

    if (responseStatus === statusCodeForSuccess) {
      const responseBodyData = await response.json();
      await onSuccess(responseBodyData);
    } else {
      const responseBodyData = await response.json();
      await onError(responseStatus, responseBodyData, responseBodyData.message || defaultErrorMessage);
    }
  } catch (err) {
    await onError(0, {}, err.message || defaultErrorMessage);
  } finally {
    await onDone();
    clearTimeout(timeoutId);
  }

}
